import React from 'react';

const SvgSelfDrive = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 100 100"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8 13)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B9BBBF",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M4.441 52.197H.912v10.479h3.529"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  d: "M13.067 69.248H9.508A1.189 1.189 0 018.32 68.06V52.752a1.19 1.19 0 011.19-1.189h55.448a3.566 3.566 0 013.566 3.567v7.863h2.432v6.255h-4.25"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M9.501 66.87H4.753V47.998H61.39a3.566 3.566 0 013.567 3.566v9.053h2.431v6.255H63.14M32.625 52.446h3.752M50.047 47.539l-4.99-10.527a4.822 4.822 0 00-4.357-2.757h-9.73v13.188"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19.8,
  cy: 66.92,
  r: 6.254,
  fill: "#FFF",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56.111,
  cy: 66.92,
  r: 6.254,
  fill: "#FFF",
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56.111,
  cy: 66.92,
  r: 2.502,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19.835,
  cy: 66.92,
  r: 2.502,
  fill: "#3F4144"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M26.68 36.81L11.636 47.997"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "square",
  strokeWidth: 2,
  d: "M49.328 66.87H26.326"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M42.367 29.266H30.851"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M26.68 47.443V34.255"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M39.433 30.361v3.365M34.07 30.339v3.365"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73.073,
  cy: 18.387,
  r: 7.132,
  fill: "#53DD7D"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70.695,
  cy: 16.01,
  r: 7.132,
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M70.336 4.122V0M76.756 6.005L79 2.548M81.154 11.084l3.737-1.742M82.102 17.706l4.083.574M79.322 23.792l3.11 2.704M73.696 27.413l1.136 3.963M66.976 27.413l-1.136 3.963M61.35 23.792l-3.11 2.704M58.57 17.707l-4.083.574M59.517 11.084L55.78 9.342M63.916 6.005l-2.245-3.457"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#3F4144",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M93.269 86.834H5.189"
})));

export default SvgSelfDrive;